import React, { useContext, useState, useEffect } from 'react'
import Proptypes from 'prop-types'
import { useSelector, useDispatch } from 'react-redux'
import {
  Button,
  Modal,
  Form,
  FormField,
  Checkbox,
  Dropdown,
  Segment,
  Header,
  Icon,
} from 'semantic-ui-react'
import * as yup from 'yup'
import { yupResolver } from '@hookform/resolvers/yup'
import Swal from 'sweetalert2'
import { useTranslation } from 'react-i18next'
import { useForm } from 'react-hook-form'
import styles from '../../../facility/facility-list/facilityList.module.css'
import { primaryColor } from '../../../../constants'
import { CustomerViewContext } from '../customer-info-view/customerView'
import { RefreshUserFacilitiesList } from '../../../../redux/actions/facility'
import IntelMsg from '../../../ItelMsg/index'
import StatusDialog from '../../../status-dialog'
import {
  GetSFDFacilityTemplate,
  saveFacility,
} from '../../../../services/facility/index'
import ValidatorGenerator from '../../../../services/configuration-template/validatores'
import {
  getHierarchy,
  addHierarchy,
  getRegions,
  GetUserCustomers,
} from '../../../../services/customer'
import './customerHierarchy.module.css'

let tenantId = ''
let product = ''

const specialChar = /^[A-Za-z0-9ء-ي _-]+$/

const formValidator = {
  name: yup
    .string()
    .trim()
    .required('Name Is Required')
    .matches(specialChar, 'Name has invalid characters'),
  id: yup.string().required('You must type Level 3 ID'),
  region: yup.string().required('You must select a region'),
  zone: yup.string().required('You must select a zone'),
  latitude: yup.string().required('You must type latitude'),
  longitude: yup.string().required('You must type longitude'),
}

const coldValidator = {
  name: yup
    .string()
    .trim()
    .required('Name Is Required')
    .matches(specialChar, 'Name has invalid characters'),
  region: yup.string().required('You must select a region'),
  zone: yup.string().required('You must select a zone'),
  Latitude: yup.number().required('You must type latitude'),
  Longitude: yup.number().required('You must type longitude'),
}

const AddSiteModal = (props) => {
  const { userEmail } = useSelector((store) => ({
    userEmail: store.auth.userEmail,
  }))
  if (userEmail) {
    const products = JSON.parse(localStorage.getItem('products'))
    product = localStorage.getItem('product')
    // eslint-disable-next-line prefer-destructuring
    tenantId = products.filter((p) => p.productName === product)[0]
  }
  const [disableSubmit, setDisableSubmit] = useState(true)
  const [open, setOpen] = useState(false)
  const { customerSettings } = useContext(CustomerViewContext)
  const [regions, setRegions] = useState([])
  const [zones, setZones] = useState([])
  const [creationData, setCreationData] = useState([])
  const [selectedFacility, setSelectedFacility] = useState('')
  const [selectedCustomer, setSelectedCustomer] = useState('')
  const [selectedCustomerTitle, setSelectedCustomerTitle] = useState('')
  const [customerEmpty, setCustomerEmpty] = useState(true)
  const [customers, setCustomers] = useState([])
  const [customerFlag, setCustomerFlag] = useState(false)
  const [xIsEmpty, setXIsEmpty] = useState(false)
  const [yIsEmpty, setYIsEmpty] = useState(false)
  const [showStatusDialog, setShowStatusDialog] = useState(false)
  const [dialogContent, setDialogContent] = useState(<></>)

  // eslint-disable-next-line no-unused-vars
  const resolve = { resolver: yupResolver(yup.object().shape(formValidator)) }
  const coldResolve = {
    resolver: yupResolver(yup.object().shape(coldValidator)),
  }

  const { register, errors, handleSubmit, setValue, clearErrors } = useForm(
    product !== 'cold' ? resolve : coldResolve,
  )
  const dispatch = useDispatch()

  const { t } = useTranslation()
  const facilityTypes = [
    { value: 'SFDA', text: 'SFDA Facility' },
    { value: 'DEFAULT', text: 'Facility' },
  ]
  const [pointsShape, setPoints] = useState('')
  const handleClose = () => {
    setOpen(false)
    setCustomerFlag(false)
    setCreationData([])
    setSelectedCustomer()
    setDisableSubmit(true)
  }
  useEffect(() => {
    GetUserCustomers(userEmail, product).then((result) => {
      console.log('customeers', result)
      if (result) {
        const list = []
        result.forEach((element) => {
          console.log('selectedFacility', selectedFacility)
          if (selectedFacility === 'SFDA') {
            if (element.type === 'SFDA_COMPANY') {
              list.push({
                value: element.tbCustomerId,
                text: element.title,
              })
            }
          } else if (selectedFacility === 'DEFAULT') {
            if (element.type === 'DEFAULT') {
              list.push({
                value: element.tbCustomerId,
                text: element.title,
              })
            }
          }
        })
        setCustomers(list)
      }
    })
  }, [selectedFacility])
  useEffect(() => {
    setOpen(props.open)
    if (product !== 'cold') {
      ;(async () => {
        if (props.open) {
          const queryParams = {
            customerId: customerSettings.tbCustomerId,
            type: 'zone',
            product,
          }
          Swal.showLoading()
          const res = await getHierarchy(queryParams)
          console.log(res)
          if (!res.success) Swal.fire('Error Garbing Level 1', '', 'error')
          else {
            Swal.close()
            setZones(res.data)
          }
        }
      })()
    }
  }, [props.open])
  useEffect(() => {
    if (zones !== null && zones !== undefined && zones.length !== 0) {
      const defaultZone = zones[0].id
      if (defaultZone) {
        grabRegions({ target: { value: defaultZone } })
      }
    }
  }, [zones])
  useEffect(() => {
    if (selectedCustomer) {
      const customer = customers.filter((c) => c.value === selectedCustomer)
      setSelectedCustomerTitle(customer[0].text)
      console.log('tit', selectedCustomerTitle)
      ;(async () => {
        const queryParams = {
          customerId: selectedCustomer,
          type: 'country',
          product,
        }
        Swal.showLoading()
        const res = await getHierarchy(queryParams)
        console.log(res)
        if (!res.success) Swal.fire('Error Garbing Level 1', '', 'error')
        else {
          Swal.close()
          setZones(res.data)
        }
      })()
    }
  }, [selectedCustomer])

  useEffect(() => {
    props.getOpenState('site', open)
  }, [open])
  const getDialogContent = (success, msg) => {
    if (success) {
      return (
        <>
          <Icon name="check" size="huge" color="green" />
          <div style={{ fontSize: 'x-large' }}>{msg}</div>
        </>
      )
    }
    return (
      <>
        <Icon name="exclamation triangle" size="huge" color="red" />
        <div style={{ fontSize: 'x-large' }}>{msg}</div>
      </>
    )
  }
  async function onSubmit(data) {
    console.log('data', data)
    if (selectedFacility === 'SFDA') {
      if (customerEmpty || xIsEmpty || yIsEmpty) {
        // setCustomerEmpty(true)
        setDialogContent(getDialogContent(false, 'Please fill missing values'))
        setShowStatusDialog(true)
      } else {
        clearErrors()
        const finalData = data
        try {
          const response = await saveFacility(
            product,
            userEmail,
            finalData,
            selectedFacility,
            selectedCustomer,
            selectedCustomerTitle,
            tenantId.tenantId,
            coordinates,
          )
          let content = <></>
          if (response.success) {
            // setRefresh(true)
            content = getDialogContent(
              true,
              response.message ? response.message : 'Facility Added',
            )
            setDialogContent(content)
            setShowStatusDialog(true)
            setOpen(false)
            dispatch(RefreshUserFacilitiesList(true))
          } else {
            // setRefresh(true)
            let { msg } = response
            msg = Array.isArray(msg)
              ? msg.map((error) => <div>{error}</div>)
              : msg
            content = getDialogContent(false, msg || 'Facility Added')
            setDialogContent(content)
            setShowStatusDialog(true)
            dispatch(RefreshUserFacilitiesList(true))
          }
        } catch (e) {
          let { msg } = e
          msg = Array.isArray(msg)
            ? msg.map((error) => (
                <>
                  <div>{error}</div>
                  <br />
                </>
              ))
            : msg
          setDialogContent(getDialogContent(false, msg || 'Facility Not Added'))
          setShowStatusDialog(true)
          setOpen(false)
        }
      }
    } else if (selectedFacility === 'DEFAULT') {
      console.log('selectedFacility', selectedFacility)
      if (customerEmpty) {
        // setCustomerEmpty(true)
        setDialogContent(getDialogContent(false, 'Please Choose Customer'))
        setShowStatusDialog(true)
      } else {
        clearErrors()
        const finalData = data
        try {
          const response = await saveFacility(
            product,
            userEmail,
            finalData,
            selectedFacility,
            selectedCustomer,
            selectedCustomerTitle,
            tenantId.tenantId,
            coordinates,
          )
          let content = <></>
          if (response.success) {
            // setRefresh(true)
            content = getDialogContent(
              true,
              response.message ? response.message : 'Facility Added',
            )
            setDialogContent(content)
            setShowStatusDialog(true)
            setOpen(false)
            dispatch(RefreshUserFacilitiesList(true))
          } else {
            // setRefresh(true)
            let { msg } = response
            msg = Array.isArray(msg)
              ? msg.map((error) => <div>{error}</div>)
              : msg
            content = getDialogContent(false, msg || 'Facility Added')
            setDialogContent(content)
            setShowStatusDialog(true)
            dispatch(RefreshUserFacilitiesList(true))
          }
        } catch (e) {
          let { msg } = e
          msg = Array.isArray(msg)
            ? msg.map((error) => (
                <>
                  <div>{error}</div>
                  <br />
                </>
              ))
            : msg
          setDialogContent(getDialogContent(false, msg || 'Facility Not Added'))
          setShowStatusDialog(true)
          setOpen(false)
        }
      }
    }
  }

  const addSite = async (data) => {
    if (data.name.trim() === '') return
    const body = {
      name: data.id,
      type: 'site',
      tenantId: tenantId.tenantId,
      label: data.name,
      searchText: data.name,
      customerId: customerSettings.tbCustomerId,
    }
    const queryParams = {
      product,
      fromId: data.region,
      fromType: 'region',
      lat: data.latitude,
      lng: data.longitude,
    }
    console.log(body)
    console.log(queryParams)
    Swal.showLoading()
    const res = await addHierarchy(queryParams, body)
    console.log(res)
    if (res.success) {
      await Swal.fire({
        title: 'Level 3 Added Successfully',
        icon: 'success',
        confirmButtonColor: 'Green',
      })
      setOpen(false)
    } else {
      Swal.fire(res.msg || 'Error adding level 3', '', 'error')
    }
  }
  const createTextField = (columnData) => {
    const validate = ValidatorGenerator(columnData['validator type'])
    return (
      <Form.Field error={errors[columnData['input name']]}>
        <strong>
          <IntelMsg id={columnData['label ID']} />
        </strong>
        <input
          ref={(ref) => {
            register(ref, { validate })
          }}
          type={columnData['input type'] === 'NUMERIC' ? 'number' : 'text'}
          step="any"
          name={columnData['input name']}
          placeholder={t(columnData.placeholder)}
        />
        {columnData['validator type'] !== 'noValidation' ? (
          <small style={{ color: 'red' }}>
            {errors[columnData['input name']] ? (
              <IntelMsg id={columnData['err msg']} />
            ) : (
              '**'
            )}
          </small>
        ) : null}
      </Form.Field>
    )
  }
  function createCheckBox(columnData) {
    register({ name: columnData['input name'], value: false })

    return (
      <Form.Field>
        <Checkbox
          label={t(columnData['header name'] || columnData['input name'])}
          name={columnData['input name']}
          onChange={(e, { name, checked }) => {
            setValue(name, checked)
          }}
        />
      </Form.Field>
    )
  }
  function createDatePicker(columnData) {
    const validate = ValidatorGenerator(columnData['validator type'])
    console.log('validator type', columnData['validator type'])
    return (
      <Form.Field error={errors[columnData['input name']]}>
        <strong>
          <IntelMsg id={columnData['label ID']} />
        </strong>
        <input
          ref={(ref) => {
            register(ref, { validate })
          }}
          type="date"
          name="date"
          placeholder={t(columnData.placeholder)}
        />
        {columnData['validator type'] !== 'noValidation' ? (
          <small style={{ color: 'red' }}>
            {errors[columnData['input name']] ? (
              <IntelMsg id={columnData['err msg']} />
            ) : (
              '**'
            )}
          </small>
        ) : null}
      </Form.Field>
    )
  }
  function createSelectField(columnData) {
    let options = []
    if (columnData['input name id'] === 'groupId') {
      return <option>dgdg</option>
    }

    if (columnData['input name id'] === 'countryName') options = []
    return (
      <Form.Field error={errors[columnData['input name']]}>
        <strong>
          <IntelMsg id={columnData['label ID']} />
        </strong>
        <select
          ref={register({
            validate: { isValidSelect: (value) => value !== '-1' },
          })}
          name={columnData['input name']}
        >
          <option value={-1}>{t(columnData.placeholder)}</option>
          {options}
        </select>
        {columnData['validator type'] !== 'noValidation' ? (
          <small style={{ color: 'red' }}>
            {errors[columnData['input name']] ? (
              <IntelMsg id={columnData['err msg']} />
            ) : (
              '**'
            )}
          </small>
        ) : null}
      </Form.Field>
    )
  }
  function createTextArea(columnData) {
    const validate = ValidatorGenerator(columnData['validator type'])
    return (
      <Form.Field>
        <strong>
          <IntelMsg id={columnData['label ID']} />
        </strong>
        <textarea
          ref={register({ validate })}
          name={columnData['input name']}
          rows={3}
        />
        {columnData['validator type'] !== 'noValidation' ? (
          <small style={{ color: 'red' }}>
            {errors[columnData['input name']] ? (
              <IntelMsg id={columnData['err msg']} />
            ) : (
              '**'
            )}
          </small>
        ) : null}
      </Form.Field>
    )
  }
  const sorting = (config1, config2) => {
    if (config1.sort < config2.sort) {
      return -1
    }
    if (config1.sort > config2.sort) {
      return 1
    }
    // a must be equal to b
    return 0
  }
  function createColumn(columnData) {
    console.log('input type', columnData['input type'])
    if (columnData['input type'] === 'STRING')
      return createTextField(columnData)
    if (columnData['input type'] === 'SELECT')
      return createSelectField(columnData)
    if (columnData['input type'] === 'TEXT_AREA')
      return createTextArea(columnData)
    if (columnData['input type'] === 'BOOLEAN') {
      return createCheckBox(columnData)
    }
    if (
      columnData['input type'] === 'HIJRI' ||
      columnData['input type'] === 'DATE'
    ) {
      return createDatePicker(columnData)
    }
    return createTextField(columnData)
  }
  const coordinates = []
  let points = ''
  async function onSubmitXY(data) {
    clearErrors()
    console.log(data)
    if (data.x === '') {
      setXIsEmpty(true)
    }
    if (data.y === '') {
      setYIsEmpty(true)
    }
    if (xIsEmpty && yIsEmpty) {
      console.log('coordinates', coordinates)
    } else {
      console.log('points', points)
      coordinates.push({ x: data.x, y: data.y })
      const shape = coordinates.map(function (item) {
        points += `${item.x},${item.y}`
        return points
      })

      setPoints(shape.concat(shape))
      console.log('coordinates', coordinates)
    }
  }
  const grabRegions = async (e) => {
    const zoneId = e.target.value || zones[0].id
    const queryParams = {
      product,
      customerId:
        product === 'cold' ? selectedCustomer : customerSettings.tbCustomerId,
    }
    Swal.showLoading()
    try {
      const res = await getRegions(queryParams, zoneId)
      if (res.success === false) throw new Error(res)
      Swal.close()
      console.log('res', res)
      setRegions(res.data)
    } catch (err) {
      Swal.fire('Error Garbing Level 2 data', '', 'error')
      console.log(err)
    }
  }
  const validateXY = ValidatorGenerator('isRequired')
  return (
    <>
      <Modal
        open={open}
        onClose={() => setOpen(false)}
        onOpen={() => setOpen(true)}
      >
        <Modal.Header>Add Level 3</Modal.Header>
        {product === 'cold' && (
          <Modal.Content scrolling style={{ height: '70%' }}>
            <Form
              id="facilityAddForm"
              onSubmit={handleSubmit(onSubmit)}
              widths="equal"
            >
              {!selectedFacility && (
                <Segment placeholder>
                  <Header icon>
                    <Icon name="boxes" />
                    Select Facility Type
                  </Header>
                </Segment>
              )}
              <FormField error={errors.facilityTypes}>
                <Dropdown
                  onFocus={() => {}}
                  name="facilityType"
                  options={facilityTypes}
                  placeholder="Select Facility"
                  fluid
                  search
                  selection
                  onChange={async (e, data) => {
                    setDisableSubmit(false)
                    setSelectedFacility(data.value)
                    setCustomerFlag(true)

                    GetSFDFacilityTemplate(data.value, product).then(
                      (configData) => {
                        if (configData['attributes map']) {
                          const creationMap = JSON.parse(
                            configData['attributes map'],
                          )
                          creationMap.sort(sorting)
                          setCreationData([])
                          setCreationData(creationMap)
                        }
                      },
                    )
                  }}
                ></Dropdown>
              </FormField>

              {customerFlag ? (
                <Form.Group>
                  <FormField error={errors[['customers']]}>
                    <strong>
                      <IntelMsg id="Customers" />
                    </strong>
                    <Dropdown
                      name="customerNames"
                      options={customers}
                      placeholder="Select a Customer"
                      fluid
                      search
                      selection
                      defaultValue=""
                      error={customerEmpty}
                      onChange={async (e, data) => {
                        setDisableSubmit(false)
                        setCustomerEmpty(false)
                        setSelectedCustomer(data.value)
                        const customer = customers.filter(
                          (c) => c.value === data.value,
                        )
                        setSelectedCustomerTitle(customer[0].text)
                      }}
                    />

                    <small style={{ color: 'red' }}>
                      {errors.customers ? (
                        <IntelMsg id={errors.customers.message} />
                      ) : (
                        '**'
                      )}
                    </small>
                  </FormField>
                  <FormField error={errors[['zone']]}>
                    <span>* Level 1 (Top Level) Name:</span>
                    <select name="zone" ref={register} onChange={grabRegions}>
                      {/* <option selected>{}</option> */}
                      <option value="" disabled selected>
                        Select Zone
                      </option>
                      {zones.map((zone) => (
                        <option key={zone.id} value={zone.id}>
                          {zone.label || zone.name}
                        </option>
                      ))}
                    </select>

                    <small style={{ color: 'red' }}>
                      {errors.zone ? (
                        <IntelMsg id={errors.zone.message} />
                      ) : (
                        '**'
                      )}
                    </small>
                  </FormField>

                  <FormField error={errors[['region']]}>
                    <span>* Level 2:</span>
                    <select name="region" ref={register}>
                      <option value="" disabled selected>
                        Select Region
                      </option>
                      {regions.map((region) => (
                        <option key={region.id} value={region.id}>
                          {region.label || region.name}
                        </option>
                      ))}
                    </select>

                    <small style={{ color: 'red' }}>
                      {errors.region ? (
                        <IntelMsg id={errors.region.message} />
                      ) : (
                        '**'
                      )}
                    </small>
                  </FormField>
                </Form.Group>
              ) : null}

              {creationData.map((rowData) => (
                <Form.Group>
                  {rowData.data.map((columnData) => createColumn(columnData))}
                </Form.Group>
              ))}
            </Form>
            {customerFlag && selectedFacility === 'SFDA' ? (
              <Form
                id="addXY"
                onSubmit={handleSubmit(onSubmitXY)}
                widths="equal"
                style={{ position: 'relative', paddingTop: '10px' }}
              >
                <Form.Group>
                  <Form.Field>
                    <strong>
                      <IntelMsg id="landCoordinatesLabel" />
                    </strong>
                  </Form.Field>
                </Form.Group>

                <Form.Group widths="equal">
                  <Form.Field error={errors[['x']]} required>
                    <strong>
                      <IntelMsg id="X Coordinate" />
                    </strong>
                    <input
                      ref={(ref) => {
                        register(ref, { validateXY })
                      }}
                      type="number"
                      step="any"
                      min="1"
                      name="x"
                      placeholder={t('X')}
                      onChange={() => {
                        setXIsEmpty(false)
                      }}
                    />
                    {xIsEmpty ? (
                      <small style={{ color: 'red' }}>
                        <IntelMsg id={['required!']} />
                      </small>
                    ) : (
                      <small style={{ color: 'red' }}>
                        <IntelMsg id={['**']} />
                      </small>
                    )}
                  </Form.Field>
                  <Form.Field error={errors[['y']]} required>
                    <strong>
                      <IntelMsg id="Y Coordinate" />
                    </strong>
                    <input
                      ref={(ref) => {
                        register(ref, { validateXY })
                      }}
                      type="number"
                      step="any"
                      name="y"
                      min="1"
                      placeholder={t('Y')}
                      onChange={() => {
                        setYIsEmpty(false)
                      }}
                    />
                    {yIsEmpty ? (
                      <small style={{ color: 'red' }}>
                        <IntelMsg id={['required!']} />
                      </small>
                    ) : (
                      <small style={{ color: 'red' }}>
                        <IntelMsg id={['**']} />
                      </small>
                    )}
                  </Form.Field>
                  <Button
                    type="submit"
                    form="addXY"
                    style={{
                      fontSize: '12px',
                      marginTop: '18px',
                      marginBottom: '20px',
                    }}
                  >
                    Add Point
                  </Button>
                </Form.Group>
                <strong>
                  <IntelMsg id={pointsShape} />
                </strong>
              </Form>
            ) : null}
          </Modal.Content>
        )}
        {product !== 'cold' && (
          <Modal.Content>
            <Form
              style={{
                padding: 10,
                borderRadius: 9,
              }}
              onSubmit={handleSubmit(addSite)}
              id="customerSettings"
            >
              <FormField error={errors[['zone']]}>
                <span>* Level 1 (Top Level) Name:</span>
                <select name="zone" ref={register} onChange={grabRegions}>
                  {/* <option selected> </option> */}
                  {zones.map((zone) => (
                    <option key={zone.id} value={zone.id}>
                      {zone.label || zone.name}
                    </option>
                  ))}
                </select>
                {errors.zone && (
                  <p style={{ color: 'red' }}>{errors.zone.message}</p>
                )}
              </FormField>

              <FormField error={errors[['region']]}>
                <span>* Level 2:</span>
                <select name="region" ref={register}>
                  <option disabled selected>
                    {' '}
                  </option>
                  {regions.map((region) => (
                    <option key={region.id} value={region.id}>
                      {region.label || region.name}
                    </option>
                  ))}
                </select>
                {errors.region && (
                  <p style={{ color: 'red' }}>{errors.region.message}</p>
                )}
              </FormField>

              <FormField error={errors[['name']]}>
                <span>* Level 3 Name:</span>
                <input
                  name="name"
                  ref={register}
                  type="text"
                  placeholder="Name"
                />
                {errors.name && (
                  <p style={{ color: 'red' }}>{errors.name.message}</p>
                )}
              </FormField>

              <FormField error={errors[['id']]}>
                <span>* Level 3 ID:</span>
                <input name="id" ref={register} type="text" placeholder="ID" />
                {errors.id && (
                  <p style={{ color: 'red' }}>{errors.id.message}</p>
                )}
              </FormField>

              <FormField error={errors[['latitude']]}>
                <span>* Latitude:</span>
                <input
                  name="latitude"
                  ref={register}
                  type="text"
                  placeholder="Latitude"
                />
                {errors.latitude && (
                  <p style={{ color: 'red' }}>{errors.latitude.message}</p>
                )}
              </FormField>

              <FormField error={errors[['longitude']]}>
                <span>* Longitude:</span>
                <input
                  name="longitude"
                  ref={register}
                  type="text"
                  placeholder="Longitude"
                />
                {errors.longitude && (
                  <p style={{ color: 'red' }}>{errors.longitude.message}</p>
                )}
              </FormField>

              <Button
                from="config form"
                type="submit"
                style={{ backgroundColor: primaryColor, color: 'white' }}
              >
                Submit
              </Button>
            </Form>
          </Modal.Content>
        )}

        <Modal.Actions>
          {product === 'cold' && (
            <Button
              type="submit"
              disabled={disableSubmit}
              form="facilityAddForm"
              className={styles.positiveStatus}
            >
              <IntelMsg id="loginSubmitButton" />
            </Button>
          )}
          <Button
            color="black"
            onClick={() => {
              handleClose()
            }}
          >
            Cancel
          </Button>
        </Modal.Actions>
      </Modal>
      <StatusDialog
        showDialog={showStatusDialog}
        setShowDialog={setShowStatusDialog}
        dialogHeader={<IntelMsg id="Facility" />}
        dialogContent={dialogContent}
      />
    </>
  )
}

AddSiteModal.propTypes = {
  open: Proptypes.bool,
  getOpenState: Proptypes.func,
}

export default AddSiteModal
